import './StatV2.scoped.scss'
import PopoverLink from './PopoverLink/PopoverLink'

export default function Stat({
  label,
  value,
  ring = false,
  segments = null,
  percent = null,
  color = '#10b981',
  additional = null,
  popover = null,
  popoverHasStat = false,
  noPadding = false
}) {
  const size = 100
  const strokeWidth = 4
  const radius = (size - strokeWidth) / 2
  const circumference = radius * 2 * Math.PI

  const getRingData = () => {
    if (segments) {
      const total = segments.reduce((sum, seg) => sum + seg.value, 0)
      const rcsSegment = segments.find(seg => seg.label === 'RCS')
      const smsSegment = segments.find(seg => seg.label === 'SMS')
      const rcsPercent = total > 0 ? (rcsSegment?.value || 0) / total * 100 : 0
      const rcsOffset = circumference - (rcsPercent / 100) * circumference

      return {
        displayValue: total.toLocaleString(),
        circles: [
          { stroke: smsSegment?.color, strokeDasharray: circumference, strokeDashoffset: 0 },
          { stroke: rcsSegment?.color, strokeDasharray: circumference, strokeDashoffset: rcsOffset, transition: true }
        ]
      }
    } else {
      const ringValue = percent || value
      const progress = (() => {
        if (typeof ringValue === 'number') return Math.min(ringValue, 100)
        const stripped = String(ringValue).replace('%', '')
        if (stripped.includes('<')) return 0.5
        return Number(stripped)
      })()
      const offset = circumference - (progress / 100) * circumference

      return {
        displayValue: Number.isInteger(value) ? value.toLocaleString() : value,
        circles: [
          {
            stroke: color,
            strokeDasharray: circumference,
            strokeDashoffset: offset,
            transition: true,
          }
        ]
      }
    }
  }

  const ringData = getRingData()

  return (
    <div className={`stat-box ${ring ? 'stat-ring' : ''} ${noPadding ? 'no-padding' : ''}`}>
      {ring ? (
        <div className="ring-container">
          <svg width={size} height={size} className="ring-svg">
            <circle
              cx={size / 2}
              cy={size / 2}
              r={radius}
              fill="none"
              stroke="#e5e7eb"
              strokeWidth={strokeWidth}
            />
            {ringData.circles.map((circleProps, index) => (
              <circle
                key={index}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                stroke={circleProps.stroke}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={circleProps.strokeDasharray}
                strokeDashoffset={circleProps.strokeDashoffset}
                style={{
                  transform: 'rotate(-90deg)',
                  transformOrigin: '50% 50%',
                  ...(circleProps.transition && {
                    transition: 'stroke-dashoffset 0.5s ease-out'
                  })
                }}
              />
            ))}
          </svg>
          <div className="ring-value">
            <h3>{ringData.displayValue}</h3>
          </div>
        </div>
      ) : (
        <h3>{Number.isInteger(value) ? value.toLocaleString() : value}</h3>
      )}
      {popover ? (
        <p className="label">
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#8792A2' }}>
            <SvgIconsQuestion width={16} height={16} />
            <PopoverLink content={popover.content} noQuestionIcon={popoverHasStat} style={{ color: '#8792A2' }}>
              <span style={{ color: '#8792A2' }}>{label}</span>
            </PopoverLink>
          </span>
        </p>
      ) : (
        <p className="label">{label}</p>
      )}
      {additional && <p className='dark-grey smaller no-margin-bottom'>{additional}</p>}
      {segments && (
        <div className="margin-top">
          {segments.map((segment, index) => {
            const total = segments.reduce((sum, seg) => sum + seg.value, 0)
            return (
              <div key={index}>
                <p className="flex align-center dark-grey smaller no-margin-top margin-bottom half">
                  <span className="color-swatch margin-right half" style={{ background: segment.color }}></span>
                  {segment.label}: {segment.value.toLocaleString()} ({total > 0 ? Math.round((segment.value / total) * 100) : 0}%)
                </p>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}